export default {
  jobList: null,
  originalJobList: null,
  jobSearchLoading: false,
  searchData: null,
  sort: 'byTime',
};
